import { PEOPLE_SEARCH_SUGGESTIONS, CLEAR_PEOPLE_SEARCH_SUGGESTIONS } from '../../constants/reducerTypes';

const initialState = {
  results: [],
  error: null,
};

export default function peopleSearchReducer(state = initialState, action) {
  switch (action.type) {
    case PEOPLE_SEARCH_SUGGESTIONS:
      return {
        ...state,
        results: action.payload.results || [],
        error: action.payload.error || null,
      };
    case CLEAR_PEOPLE_SEARCH_SUGGESTIONS:
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
